// components/NumberRangeFilter.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * A component for filtering by a number range with min and max inputs
 * 
 * @param {Object} props - Component props
 * @param {string} props.label - Label for the range filter
 * @param {string|number} props.minValue - The current minimum value
 * @param {string|number} props.maxValue - The current maximum value
 * @param {Function} props.onMinChange - Function to call when the min value changes
 * @param {Function} props.onMaxChange - Function to call when the max value changes
 */
export const NumberRangeFilter = ({
  label,
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
}) => {
  const handleMinChange = (e) => {
    onMinChange(e.target.value);
  };

  const handleMaxChange = (e) => {
    onMaxChange(e.target.value);
  };

  return (
    <Box>
      <Typography 
        variant="subtitle2" 
        gutterBottom={false}
        sx={{ fontSize: '0.85rem' }}
      >
        {label}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
        <input
          type="number"
          value={minValue}
          onChange={handleMinChange}
          placeholder="Min"
          className="multiple-number-input"
          style={{ flex: 1, minWidth: 0, boxSizing: 'border-box' }}
        />
        <input
          type="number"
          value={maxValue}
          onChange={handleMaxChange}
          placeholder="Max"
          className="multiple-number-input"
          style={{ flex: 1, minWidth: 0, boxSizing: 'border-box' }}
        />
      </Box>
    </Box>
  );
};